import { render, staticRenderFns } from "./cpd-provider-report.vue?vue&type=template&id=2565c8d0&scoped=true"
import script from "./cpd-provider-report.vue?vue&type=script&lang=js"
export * from "./cpd-provider-report.vue?vue&type=script&lang=js"
import style0 from "./cpd-provider-report.vue?vue&type=style&index=0&id=2565c8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565c8d0",
  null
  
)

export default component.exports